var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_3492_33157)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.87266 11.3857L8.25858 6.99979L3.87266 2.61387C3.78724 2.52845 3.78724 2.38994 3.87266 2.30451L4.49146 1.68572C4.57689 1.60029 4.71539 1.60029 4.80082 1.68572L9.80553 6.69043C9.97639 6.86128 9.97639 7.13829 9.80553 7.30915L4.80082 12.3139C4.71539 12.3993 4.57689 12.3993 4.49146 12.3139L3.87266 11.6951C3.78724 11.6096 3.78724 11.4711 3.87266 11.3857Z","fill":"black"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_3492_33157"},React.createElement("rect",{"width":"14","height":"14","fill":"white","transform":"translate(0 14) rotate(-90)"})))]);
}

ArrowRight.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
